import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
	routes: [
		{
			path: '/',
			component: () => import( /* webpackChunkName: "login" */ '@/components/lianmeng/Shouye.vue')
		},
		{
			path: '/login',
			component: () => import( /* webpackChunkName: "login" */ '@/components/home/Home.vue')
			// component: () => import( /* webpackChunkName: "login" */ '@/components/page/Login.vue')
		},
		// {
		// 	path: '/logins',
		// 	component: () => import( /* webpackChunkName: "login" */ '@/components/page/Logins.vue')
		// },
		// {
		// 	path: '/sso',
		// 	component: () => import( /* webpackChunkName: "sso" */ '@/components/page/sso.vue')
		// },
		{
			path: '*',
			redirect: '/404'

		},
		{
			path: '/shouye',
			component: () => import('@/components/lianmeng/Shouye.vue')
		}, {
			path: '/yonghuzhuce',
			component: () => import('@/components/lianmeng/Yonhuzhuce.vue')
		},{
			path: '/baoming',
			component: () => import('@/components/lianmeng/Baoming.vue')
		},{
			path: '/chanpindingwei',
			component: () => import('@/components/lianmeng/Chanpindingwei.vue')
		},{
			path: '/jiangshijieshao',
			component: () => import('@/components/lianmeng/Jiangshijieshao.vue')
		},{
			path: '/jiangshilist',
			component: () => import('@/components/lianmeng/Jiangshilist.vue')
		},{
			path: '/shipinzhishi',
			component: () => import('@/components/lianmeng/Shipinzhishi.vue')
		},{
			path: '/zlkc',
			component: () => import('@/components/lianmeng/Zlkc.vue')
		},{
			path: '/spbf',
			component: () => import('@/components/lianmeng/Spbf.vue')
		},{
			path: '/zspj',
			component: () => import('@/components/lianmeng/Zspj.vue')
		},{
			path: '/xgzs',
			component: () => import('@/components/lianmeng/Xgzs.vue')
		},{
			path: '/zxzhibo',
			component: () => import('@/components/lianmeng/Zxzhibo.vue')
		},{
			path: '/gerenkc',
			component: () => import('@/components/lianmeng/Gerenkc.vue')
		},{
			path: '/woyaobaoming',
			component: () => import('@/components/lianmeng/Woyaobaoming.vue')
		},{
			path: '/zhifu',
			component: () => import('@/components/lianmeng/Zhifu.vue')
		},{
			path: '/guanyuwomen',
			component: () => import('@/components/lianmeng/Guanyuwomen.vue')
		},{
			path: '/shishifangan',
			component: () => import('@/components/lianmeng/Shishifangan.vue')
		},{
			path: '/ssxq',
			component: () => import('@/components/lianmeng/Ssxq.vue')
		},{
			path: '/lianxiwomen',
			component: () => import('@/components/lianmeng/Lianxiwomen.vue')
		},{
			path: '/zhengshuchaxun',
			component: () => import('@/components/lianmeng/Zhengshuchaxun.vue')
		},{
			path: '/woyaopeixun',
			component: () => import('@/components/lianmeng/Woyaopeixun.vue')
		},{
			path: '/zhuanyerenzheng',
			component: () => import('@/components/lianmeng/Zhuanyerenzheng.vue')
		},{
			path: '/zhiboxiangqing',
			component: () => import('@/components/lianmeng/Zhiboxiangqing.vue')
		},
	]
});

